<template lang="pug">

  a-entity.home

    gyro-view
    router-view
    logo(:modeSwitchable="true")
    menus(v-if="showMenu")
    gallery(v-if="showGallery")
    qr-page(v-if="showQRPage")
    map-title




</template>
<script>
import {mapState, mapMutations} from 'vuex'
import Logo from 'src/components/vca/widgets/Logo'

import Menus from 'src/components/vca/menu/Menu'
import Gallery from 'src/components/vca/gallery/Gallery'
import QRPage from 'src/components/vca/widgets/QRPage3'
import * as MODES from 'src/config/modes'

import GyroView from 'src/components/vca/scenes/GyroView7'
import MapTitle from "src/components/vca/widgets/MapTitle2"

export default {
  name: "Home",
  props: {

  },
  components: {
    MapTitle,

    GyroView,
    Logo,

    Menus,
    Gallery,
    'qr-page': QRPage,
  },
  data() {
    return {
      MODES,

    }
  },
  computed:{
    ...mapState('app', ['mode', 'showMenu', 'showGallery', 'showQRPage'])
  },
  methods: {
    ...mapMutations('app', ['toggleMode']),

    init() {},
    animate() {},

  },
  mounted() {
    this.init()
    this.animate()



  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .home
    .logo
      z-index: 800
    .button-menu
      z-index: 110
    .menu
      z-index: 900
    .qr-page
      z-index: 999
    .gallery
      z-index: 200
    .map-title
      z-index: 800





</style>